import React, {useEffect} from 'react'
import styled from 'styled-components'

import { Button, Spinner } from 'components'
import { ImageInput } from 'features'
import { FaUserAlt, FaEdit } from 'react-icons/fa'
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';

const defaultStyle = {
    size: '2rem',
    color: 'white'
}



const Image = styled.img`
    width: ${props => props.style.size};
    height: ${props => props.style.size};
    object-fit: cover; 
    border-radius: 50%;
    border: 1px solid var(--secondary-color);
    grid-row: 1/ span 1;
    grid-column: 1/ span 1;
    align-self: center;
    justify-self: center;
`

const ImagePlaceholder = styled.div`
    width: ${props => props.style.size};
    height: ${props => props.style.size};
    object-fit: cover; 
    border-radius: 50%;
    border: 1px solid var(--secondary-color);
    grid-row: 1/ span 1;
    grid-column: 1/ span 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--secondary-color);
`

const EditContainer = styled.div`
    width: ${props => props.style.size};
    height: ${props => props.style.size};
    object-fit: contain; 
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    grid-row: 1/ span 1;
    grid-column: 1/ span 1;
    opacity: 0;
`

const Container = styled.div`
    cursor: pointer;
    display: grid;
    grid-template-columns: ${props => props.style.size};
    grid-template-rows: ${props => props.style.size};
    &:hover ${EditContainer} {
        opacity: 1;
    }
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    color: 'white';
`

const ProfileImage = props => {
    const {
        img,
        style,
        onSelect,
    } = props;
    let updatedStyle = Object.assign({}, defaultStyle, style)
    const [hover, setHover] = React.useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, openPopper] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [value, setValue] = React.useState(null)

    useEffect(() => {
        img === value && setLoading(false)
    }, [img])

    const clickHandler = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        openPopper(!open);
    }

    const onSubmit = (url) => {
        // Close input
        clickHandler()

        // Load spinner
        // setLoading(true)

        // Return url
        onSelect(url)
        setValue(url)
    }

    if(onSelect){
        return (
            <Container style={updatedStyle} >
                {img ? <Image src={img} style={updatedStyle} onClick={clickHandler}/> : <ImagePlaceholder onClick={clickHandler} style={updatedStyle}><FaUserAlt/></ImagePlaceholder>}
                <EditContainer style={updatedStyle} onClick={clickHandler}>
                    {loading ? <Spinner/> : <FaEdit style={{color: 'white'}}/>}
                    <Subtitle>{loading ? 'Updating' : 'Edit'}</Subtitle>
                </EditContainer>

                {open && 
                <Modal onBackdropClick={clickHandler} open={open} BackdropProps={{invisible:true, style:{zIndex: 1300}}}>
                    <Popper style={{zIndex: 1300, outline: 'none'}} id='TagInputPopper' open={open} anchorEl={anchorEl} placement='bottom' transition>
                        {({ TransitionProps }) => (
                        <Fade {...TransitionProps} timeout={{enter: 300, exit: 300}}>
                            <ImageInput onSubmit={onSubmit} onClose={clickHandler}/>
                        </Fade>
                        )}
                    </Popper>
                </Modal>}
            </Container>
        )
    } else {
        return (
            img ? <Image src={img} style={updatedStyle}/> : <ImagePlaceholder style={updatedStyle}><FaUserAlt/></ImagePlaceholder>
        )
    }
    
}

export default ProfileImage